var exports = {
  "de": "PopoverContainer__mXp8LB",
  "hl": "PopoverContent__9JFUe9",
  "DZ": "Heading__19uYlY",
};

module.exports = exports;
